// src/jsx/pages/reports/PanchayathAccountsReportPage.jsx

import React, {

  useEffect,

  useMemo,

  useState,

} from "react";

import {

  Button,

  Card,

  Col,

  Dropdown,

  Form,

  InputGroup,

  Pagination,

  Row,

  Spinner,

  Table,

} from "react-bootstrap";

import {

  AlertCircle,

  CheckCircle,

  Download,

  FileText,

  RefreshCcw,

  Search,

  TrendingUp,

  Clock,

  CreditCard,

} from "react-feather";

import {

  useDispatch,

  useSelector,

} from "react-redux";

import {

  toast,

} from "react-toastify";

import {

  clearPanchayathSubscriptionReportError,

  exportPanchayathSubscriptionReportThunk,

  fetchPanchayathSubscriptionReportThunk,

  REPORT_TYPES,

} from "../../../store/slices/panchayathSubscriptionReportsSlice";

import {

  fetchPanchayathsThunk,

} from "../../../store/slices/panchayathMasterSlice";

import "./ReportPage.css";

const REPORT_TYPE =

  REPORT_TYPES.PANCHAYATH_ACCOUNTS;

const currentMonth = () => {

  const d = new Date();

  return `${d.getFullYear()}-${String(

    d.getMonth() + 1

  ).padStart(2, "0")}`;

};

const money = (value) =>

  new Intl.NumberFormat(

    "en-IN",

    {

      style: "currency",

      currency: "INR",

      minimumFractionDigits: 2,

      maximumFractionDigits: 2,

    }

  ).format(

    Number(value || 0)

  );

const safe = (

  value,

  fallback = "—"

) =>

  value === null ||

  value === undefined ||

  value === ""

    ? fallback

    : value;

const formatDate = (value) => {

  if (!value) {

    return "—";

  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {

    return "—";

  }

  return new Intl.DateTimeFormat(

    "en-GB",

    {

      day: "2-digit",

      month: "2-digit",

      year: "numeric",

    }

  ).format(date);

};

const formatCategory = (value) => {

  const items = String(value || "")

    .split(",")

    .map((item) => item.trim())

    .filter(Boolean);

  if (!items.length) {

    return "—";

  }

  return items

    .map(

      (item) =>

        item.charAt(0).toUpperCase() +

        item.slice(1)

    )

    .join(", ");

};

const downloadBlob = (

  blob,

  fileName

) => {

  const url =

    window.URL.createObjectURL(

      blob

    );

  const anchor =

    document.createElement(

      "a"

    );

  anchor.href = url;

  anchor.download = fileName;

  document.body.appendChild(

    anchor

  );

  anchor.click();

  anchor.remove();

  window.URL.revokeObjectURL(

    url

  );

};

const ReportPagination = ({

  loading,

  page,

  totalPages,

  setPage,

}) => {

  if (totalPages <= 1) {

    return null;

  }

  const maxButtons = 5;

  let start = Math.max(

    1,

    page -

      Math.floor(

        maxButtons / 2

      )

  );

  let end = Math.min(

    totalPages,

    start +

      maxButtons -

      1

  );

  start = Math.max(

    1,

    end -

      maxButtons +

      1

  );

  const pages = [];

  for (

    let p = start;

    p <= end;

    p += 1

  ) {

    pages.push(p);

  }

  return (

    <Pagination className="mb-0">

      <Pagination.Prev

        disabled={

          loading ||

          page <= 1

        }

        onClick={() =>

          setPage(

            Math.max(

              1,

              page - 1

            )

          )

        }

      >

        Prev

      </Pagination.Prev>

      {pages.map(

        (p) => (

          <Pagination.Item

            key={p}

            active={

              p === page

            }

            disabled={

              loading

            }

            onClick={() =>

              setPage(p)

            }

          >

            {p}

          </Pagination.Item>

        )

      )}

      <Pagination.Next

        disabled={

          loading ||

          page >= totalPages

        }

        onClick={() =>

          setPage(

            Math.min(

              totalPages,

              page + 1

            )

          )

        }

      >

        Next

      </Pagination.Next>

    </Pagination>

  );

};

const PanchayathSearchDropdown = ({

  value,

  onChange,

  items = [],

  loading = false,

}) => {

  const [open, setOpen] = useState(false);

  const [searchText, setSearchText] = useState("");

  const selected =

    items.find(

      (item) =>

        String(item?.pan_id) === String(value)

    ) || null;

  const normalizedSearch =

    String(searchText || "")

      .trim()

      .toLowerCase();

  const filteredItems =

    normalizedSearch

      ? items.filter((item) => {

          const name =

            String(item?.pan_name || "")

              .toLowerCase();

          const id =

            String(item?.pan_id || "")

              .toLowerCase();

          return (

            name.includes(normalizedSearch) ||

            id.includes(normalizedSearch)

          );

        })

      : items;

  const selectItem = (nextValue) => {

    onChange(nextValue);

    setSearchText("");

    setOpen(false);

  };

  return (

    <Dropdown

      show={open}

      onToggle={(nextOpen) => {

        setOpen(nextOpen);

        if (!nextOpen) {

          setSearchText("");

        }

      }}

      className="report-pan-dropdown"

    >

      <Dropdown.Toggle

        disabled={loading}

        className="report-pan-dropdown-toggle"

      >

        <span

          className={

            selected

              ? "report-pan-dropdown-value"

              : "report-pan-dropdown-placeholder"

          }

        >

          {loading

            ? "Loading Panchayaths..."

            : selected

            ? selected.pan_name

            : "All Panchayaths"}

        </span>

        <span className="report-pan-dropdown-caret">

          ▾

        </span>

      </Dropdown.Toggle>

      <Dropdown.Menu className="report-pan-dropdown-menu">

        <div

          className="report-pan-dropdown-search-wrap"

          onClick={(event) => event.stopPropagation()}

        >

          <Search

            size={15}

            className="report-pan-dropdown-search-icon"

          />

          <Form.Control

            autoFocus

            type="text"

            value={searchText}

            placeholder="Search Panchayath..."

            className="report-pan-dropdown-search"

            onChange={(event) =>

              setSearchText(event.target.value)

            }

            onKeyDown={(event) =>

              event.stopPropagation()

            }

          />

        </div>

        <div className="report-pan-dropdown-options">

          {!normalizedSearch && (

            <Dropdown.Item

              active={!value}

              className="report-pan-dropdown-item"

              onClick={() => selectItem("")}

            >

              <div className="report-pan-option-main">

                All Panchayaths

              </div>

            </Dropdown.Item>

          )}

          {filteredItems.length ? (

            filteredItems.map((item) => {

              const isActive =

                String(item.pan_id) === String(value);

              return (

                <Dropdown.Item

                  key={item.pan_id}

                  active={isActive}

                  className="report-pan-dropdown-item"

                  onClick={() =>

                    selectItem(String(item.pan_id))

                  }

                >

                  <div className="report-pan-option-main">

                    {item.pan_name}

                  </div>

                  <div className="report-pan-option-sub">

                    Panchayath ID #{item.pan_id}

                  </div>

                </Dropdown.Item>

              );

            })

          ) : (

            <div className="report-pan-dropdown-empty">

              No Panchayath found

            </div>

          )}

        </div>

      </Dropdown.Menu>

    </Dropdown>

  );

};

const PanchayathAccountsReportPage =

  () => {

    const dispatch =

      useDispatch();

    const report =

      useSelector(

        (state) =>

          state

            .panchayathSubscriptionReports

            ?.panchayath_accounts || {

            rows: [],

            meta: {},

          }

      );

    const {

      loading = false,

      exportLoading = false,

      error = null,

    } =

      useSelector(

        (state) =>

          state

            .panchayathSubscriptionReports ||

          {}

      );

    const {

      rows:

        panchayaths = [],

      loading:

        panchayathLoading = false,

    } =

      useSelector(

        (state) =>

          state

            .panchayathMaster ||

          {}

      );

    const rows =

      report.rows || [];

    const meta =

      report.meta || {};

    const summary =

      meta.summary || {};

    const tableTotals =
      useMemo(() => {
        const totals = {
          subscription_amount: 0,
          bills_generated: 0,
          invoice_generated: 0,
          invoice_pending: 0,
          invoice_amount: 0,
          total_collected: 0,
          receipt_pending_approval: 0,
          total_pending: 0,
        };

        rows.forEach((row) => {
          totals.subscription_amount +=
            Number(
              row?.subscription_amount || 0
            );

          totals.bills_generated +=
            Number(
              row?.bills_generated || 0
            );

          totals.invoice_generated +=
            Number(
              row?.invoice_generated || 0
            );

          totals.invoice_pending +=
            Number(
              row?.invoice_pending || 0
            );

          totals.invoice_amount +=
            Number(
              row?.invoice_amount || 0
            );

          totals.total_collected +=
            Number(
              row?.total_collected || 0
            );

          totals.receipt_pending_approval +=
            Number(
              row?.receipt_pending_approval || 0
            );

          totals.total_pending +=
            Number(
              row?.total_pending || 0
            );
        });

        totals.collection_percentage =
          totals.invoice_amount > 0
            ? Math.min(
                100,
                (
                  totals.total_collected /
                  totals.invoice_amount
                ) * 100
              )
            : 0;

        return totals;
      }, [rows]);

    const [

      searchInput,

      setSearchInput,

    ] =

      useState("");

    const [

      search,

      setSearch,

    ] =

      useState("");

    const [

      panId,

      setPanId,

    ] =

      useState("");

    const [

      month,

      setMonth,

    ] =

      useState(

        currentMonth()

      );

    const [

      category,

      setCategory,

    ] =

      useState("");

    const [

      page,

      setPage,

    ] =

      useState(1);

    const [

      pageSize,

      setPageSize,

    ] =

      useState(20);

    const filters =

      useMemo(

        () => ({

          page,

          pageSize,

          search,

          pan_id:

            panId,

          month,

          category,

        }),

        [

          page,

          pageSize,

          search,

          panId,

          month,

          category,

        ]

      );

    useEffect(

      () => {

        dispatch(

          fetchPanchayathsThunk()

        );

      },

      [dispatch]

    );

    useEffect(

      () => {

        dispatch(

          fetchPanchayathSubscriptionReportThunk({

            reportType:

              REPORT_TYPE,

            filters,

          })

        );

        // eslint-disable-next-line react-hooks/exhaustive-deps

      },

      [

        page,

        pageSize,

        search,

        panId,

        month,

        category,

      ]

    );

    useEffect(

      () => {

        if (!error) {

          return;

        }

        toast.error(

          String(error)

        );

        dispatch(

          clearPanchayathSubscriptionReportError()

        );

      },

      [

        error,

        dispatch,

      ]

    );

    const submitSearch =

      (event) => {

        event?.preventDefault();

        setPage(1);

        setSearch(

          searchInput.trim()

        );

      };

    const clearFilters =

      () => {

        setSearchInput("");

        setSearch("");

        setPanId("");

        setMonth(

          currentMonth()

        );

        setCategory("");

        setPage(1);

        setPageSize(20);

      };

    const handleExport =

      async (

        format

      ) => {

        try {

          const result =

            await dispatch(

              exportPanchayathSubscriptionReportThunk({

                reportType:

                  REPORT_TYPE,

                format,

                filters: {

                  ...filters,

                  page: 1,

                },

              })

            ).unwrap();

          downloadBlob(

            result.blob,

            `panchayath_accounts_${month}.${format === "excel" ? "xlsx" : "pdf"}`

          );

        } catch (e) {

          toast.error(

            String(

              e ||

                "Export failed"

            )

          );

        }

      };

    const totalRecords =

      Number(

        meta.totalRecords ||

          0

      );

    const totalPages =

      Math.max(

        1,

        Number(

          meta.totalPages ||

            1

        )

      );

    const currentPage =

      Math.max(

        1,

        Number(

          meta.page ||

            page

        )

      );

    const totalInvoiceAmount =

      Number(

        summary

          .total_invoice_amount ||

          0

      );

    const totalCollected =

      Number(

        summary

          .total_collected ||

          0

      );

    const totalPending =

      Number(

        summary

          .total_pending ||

          0

      );

    const invoiceGeneratedCount =

      Number(

        summary

          .invoice_generated_count ||

          0

      );

    const invoicePendingCount =

      Number(

        summary

          .invoice_generation_pending_count ||

          0

      );

    const receiptPendingApproval =

      Number(

        summary

          .receipt_pending_approval ||

          0

      );

    return (

      <div className="report-page">

        <Card className="report-card">

          <Card.Header className="report-card-header">

            <div className="report-header-row">

              <div>

                <div className="report-title">

                  Panchayath Accounts Report

                </div>

                <div className="report-subtitle">

                  Panchayath-wise invoice, collection, receipt and pending account summary.

                </div>

              </div>

            </div>

          </Card.Header>

          <Card.Body>

            <Row className="g-3 mb-3">

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon">

                    <FileText size={17} />

                  </div>

                  <div className="report-summary-label">

                    Total Invoice Amount

                  </div>

                  <div className="report-summary-value">

                    {money(

                      totalInvoiceAmount

                    )}

                  </div>

                </div>

              </Col>

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon success">

                    <CheckCircle size={17} />

                  </div>

                  <div className="report-summary-label">

                    Total Collected

                  </div>

                  <div className="report-summary-value">

                    {money(

                      totalCollected

                    )}

                  </div>

                </div>

              </Col>

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon danger">

                    <AlertCircle size={17} />

                  </div>

                  <div className="report-summary-label">

                    Total Pending

                  </div>

                  <div className="report-summary-value">

                    {money(

                      totalPending

                    )}

                  </div>

                </div>

              </Col>

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon info">

                    <CreditCard size={17} />

                  </div>

                  <div className="report-summary-label">

                    Invoices Generated

                  </div>

                  <div className="report-summary-value">

                    {invoiceGeneratedCount.toLocaleString(

                      "en-IN"

                    )}

                  </div>

                </div>

              </Col>

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon warning">

                    <Clock size={17} />

                  </div>

                  <div className="report-summary-label">

                    Invoice Pending

                  </div>

                  <div className="report-summary-value">

                    {invoicePendingCount.toLocaleString(

                      "en-IN"

                    )}

                  </div>

                </div>

              </Col>

              <Col xl={2} md={4} sm={6}>

                <div className="report-summary-card">

                  <div className="report-summary-icon pending">

                    <TrendingUp size={17} />

                  </div>

                  <div className="report-summary-label">

                    Receipt Pending Approval

                  </div>

                  <div className="report-summary-value">

                    {money(

                      receiptPendingApproval

                    )}

                  </div>

                </div>

              </Col>

            </Row>

            <div className="report-filter-box">

              <Row className="g-3">

                <Col xl={3} md={6}>

                  <Form.Label className="report-label">

                    Month

                  </Form.Label>

                  <Form.Control

                    type="month"

                    value={month}

                    disabled={

                      loading

                    }

                    onChange={(

                      event

                    ) => {

                      setPage(1);

                      setMonth(

                        event

                          .target

                          .value

                      );

                    }}

                  />

                </Col>

                <Col xl={3} md={6}>

                  <Form.Label className="report-label">

                    Panchayath

                  </Form.Label>

                  <PanchayathSearchDropdown

                    value={panId}

                    items={panchayaths || []}

                    loading={

                      loading ||

                      panchayathLoading

                    }

                    onChange={(nextPanId) => {

                      setPage(1);

                      setPanId(nextPanId);

                    }}

                  />

                </Col>

                <Col xl={2} md={6}>

                  <Form.Label className="report-label">

                    Category

                  </Form.Label>

                  <Form.Select

                    value={category}

                    disabled={loading}

                    onChange={(event) => {

                      setPage(1);

                      setCategory(

                        event.target.value

                      );

                    }}

                  >

                    <option value="">

                      All Categories

                    </option>

                    <option value="subscription">

                      Subscription

                    </option>

                    <option value="installation">

                      Installation

                    </option>

                    <option value="training">

                      Training

                    </option>

                    <option value="printer">

                      Printer

                    </option>

                    <option value="other">

                      Other

                    </option>

                  </Form.Select>

                </Col>

                <Col xl={2} md={6}>

                  <Form

                    onSubmit={

                      submitSearch

                    }

                  >

                    <Form.Label className="report-label">

                      Search

                    </Form.Label>

                    <InputGroup className="report-search w-100">

                      <InputGroup.Text>

                        <Search size={16} />

                      </InputGroup.Text>

                      <Form.Control

                        value={

                          searchInput

                        }

                        disabled={

                          loading

                        }

                        placeholder="Search Panchayath..."

                        onChange={(

                          event

                        ) =>

                          setSearchInput(

                            event

                              .target

                              .value

                          )

                        }

                      />

                      <Button

                        type="submit"

                        variant="primary"

                      >

                        Search

                      </Button>

                    </InputGroup>

                  </Form>

                </Col>

                <Col

                  xl={2}

                  md={4}

                  className="d-flex align-items-end"

                >

                  <Button

                    className="report-btn w-100"

                    variant="outline-secondary"

                    disabled={

                      loading

                    }

                    onClick={

                      clearFilters

                    }

                  >

                    <RefreshCcw

                      size={16}

                      className="me-2"

                    />

                    Clear

                  </Button>

                </Col>

              </Row>

            </div>

            <div className="report-table-toolbar">

              <div className="report-table-title">

                Panchayath Accounts{" "}

                {category ? (

                  <span className="report-active-filter">

                    {category.charAt(0).toUpperCase() +

                      category.slice(1)}

                  </span>

                ) : null}{" "}

                <span className="report-count">

                  (

                  {totalRecords.toLocaleString(

                    "en-IN"

                  )}{" "}

                  records)

                </span>

              </div>

              <div className="report-table-right">

                <Button

                  className="report-btn"

                  variant="outline-primary"

                  disabled={

                    loading ||

                    exportLoading ||

                    !totalRecords

                  }

                  onClick={() =>

                    handleExport(

                      "excel"

                    )

                  }

                >

                  <Download

                    size={16}

                    className="me-2"

                  />

                  Excel

                </Button>

                <Button

                  className="report-btn"

                  variant="outline-danger"

                  disabled={

                    loading ||

                    exportLoading ||

                    !totalRecords

                  }

                  onClick={() =>

                    handleExport(

                      "pdf"

                    )

                  }

                >

                  <Download

                    size={16}

                    className="me-2"

                  />

                  PDF

                </Button>

              </div>

            </div>

            <div className="report-table-wrap">

              <div className="report-table-scroll report-accounts-table-scroll">

                <Table

                  hover

                  className="mb-0 report-table align-middle"

                >

                  <thead>

                    <tr>

                      <th>

                        Sl. No.

                      </th>

                      <th>

                        Panchayath

                      </th>

                      <th>

                        Category

                      </th>

                      <th>

                        Last Bill Date

                      </th>

                      <th>

                        Last Invoice Date

                      </th>

                      <th>

                        Last Receipt Date

                      </th>

                      <th className="text-end">

                        Subscription Amount

                      </th>

                      <th className="text-center">

                        Bills Generated

                      </th>

                      <th className="text-center">

                        Invoice Generated

                      </th>

                      <th className="text-center">

                        Invoice Pending

                      </th>

                      <th className="text-end">

                        Invoice Amount

                      </th>

                      <th className="text-end">

                        Total Collected

                      </th>

                      <th className="text-end">

                        Receipt Pending

                      </th>

                      <th className="text-end">

                        Total Pending

                      </th>

                      <th className="text-center">

                        Collection %

                      </th>

                      <th>

                        Status

                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {loading ? (

                      <tr>

                        <td

                          colSpan={16}

                          className="text-center py-5"

                        >

                          <Spinner

                            animation="border"

                            size="sm"

                            className="me-2"

                          />

                          Loading...

                        </td>

                      </tr>

                    ) : rows.length ? (

                      <>
                        {rows.map(

                        (

                          row,

                          index

                        ) => {

                          const status =

                            String(

                              row.account_status ||

                                ""

                            )

                              .trim()

                              .toLowerCase();

                          return (

                            <tr

                              key={

                                row.pan_id ||

                                index

                              }

                            >

                              <td>

                                {safe(

                                  row.sl_no,

                                  index + 1

                                )}

                              </td>

                              <td>

                                <div className="fw-semibold">

                                  {safe(

                                    row.pan_name

                                  )}

                                </div>

                                {row.pan_id ? (

                                  <div className="text-muted small">

                                    #{row.pan_id}

                                  </div>

                                ) : null}

                              </td>

                              <td>

                                {row.categories ? (

                                  <span className="report-category-badge">

                                    {formatCategory(

                                      row.categories

                                    )}

                                  </span>

                                ) : (

                                  "—"

                                )}

                              </td>

                              <td>

                                <span className="report-date-value">

                                  {formatDate(

                                    row.last_bill_date

                                  )}

                                </span>

                              </td>

                              <td>

                                <span className="report-date-value">

                                  {formatDate(

                                    row.last_invoice_date

                                  )}

                                </span>

                              </td>

                              <td>

                                <span className="report-date-value">

                                  {formatDate(

                                    row.last_receipt_date

                                  )}

                                </span>

                              </td>

                              <td className="text-end">

                                {row.subscription_amount === null ||

                                  row.subscription_amount === undefined

                                  ? "—"

                                  : money(

                                      row.subscription_amount

                                    )}

                              </td>

                              <td className="text-center">

                                {Number(

                                  row.bills_generated ||

                                    0

                                )}

                              </td>

                              <td className="text-center">

                                {Number(

                                  row.invoice_generated ||

                                    0

                                )}

                              </td>

                              <td className="text-center">

                                {Number(

                                  row.invoice_pending ||

                                    0

                                )}

                              </td>

                              <td className="text-end">

                                {money(

                                  row.invoice_amount

                                )}

                              </td>

                              <td className="text-end text-success fw-semibold">

                                {money(

                                  row.total_collected

                                )}

                              </td>

                              <td className="text-end">

                                {money(

                                  row.receipt_pending_approval

                                )}

                              </td>

                              <td className="text-end text-danger fw-semibold">

                                {money(

                                  row.total_pending

                                )}

                              </td>

                              <td className="text-center">

                                {Number(

                                  row.collection_percentage ||

                                    0

                                ).toFixed(

                                  2

                                )}

                                %

                              </td>

                              <td>

                                <span

                                  className={`report-account-status ${status}`}

                                >

                                  {safe(

                                    row.account_status_label ||

                                      row.account_status

                                  )}

                                </span>

                              </td>

                            </tr>

                          );

                        }

                      )}

                        <tr className="report-total-row">
                          <td>—</td>

                          <td>
                            <strong>TOTAL</strong>
                          </td>

                          <td>—</td>
                          <td>—</td>
                          <td>—</td>
                          <td>—</td>

                          <td className="text-end">
                            {category &&
                            category !== "subscription"
                              ? "—"
                              : money(
                                  tableTotals.subscription_amount
                                )}
                          </td>

                          <td className="text-center">
                            {tableTotals.bills_generated.toLocaleString(
                              "en-IN"
                            )}
                          </td>

                          <td className="text-center">
                            {tableTotals.invoice_generated.toLocaleString(
                              "en-IN"
                            )}
                          </td>

                          <td className="text-center">
                            {tableTotals.invoice_pending.toLocaleString(
                              "en-IN"
                            )}
                          </td>

                          <td className="text-end">
                            {money(
                              tableTotals.invoice_amount
                            )}
                          </td>

                          <td className="text-end text-success">
                            {money(
                              tableTotals.total_collected
                            )}
                          </td>

                          <td className="text-end">
                            {money(
                              tableTotals.receipt_pending_approval
                            )}
                          </td>

                          <td className="text-end text-danger">
                            {money(
                              tableTotals.total_pending
                            )}
                          </td>

                          <td className="text-center">
                            {Number(
                              tableTotals.collection_percentage || 0
                            ).toFixed(2)}
                            %
                          </td>

                          <td>—</td>
                        </tr>
                      </>
                    ) : (

                      <tr>

                        <td

                          colSpan={16}

                          className="text-center py-5 text-muted"

                        >

                          No account data found

                        </td>

                      </tr>

                    )}

                  </tbody>

                </Table>

              </div>

              <div className="report-pagination-bar">

                <div className="report-page-size">

                  <span>

                    Rows:

                  </span>

                  <Form.Select

                    value={

                      pageSize

                    }

                    className="page-size-select"

                    disabled={

                      loading

                    }

                    onChange={(

                      event

                    ) => {

                      setPage(1);

                      setPageSize(

                        Number(

                          event

                            .target

                            .value

                        )

                      );

                    }}

                  >

                    {[

                      10,

                      20,

                      50,

                      100,

                    ].map(

                      (

                        size

                      ) => (

                        <option

                          key={

                            size

                          }

                          value={

                            size

                          }

                        >

                          {size}

                        </option>

                      )

                    )}

                  </Form.Select>

                </div>

                <ReportPagination

                  loading={

                    loading

                  }

                  page={

                    currentPage

                  }

                  totalPages={

                    totalPages

                  }

                  setPage={

                    setPage

                  }

                />

                <div className="report-page-info">

                  Page{" "}

                  {currentPage} /{" "}

                  {totalPages}

                </div>

              </div>

            </div>

          </Card.Body>

        </Card>

      </div>

    );

  };

export default

PanchayathAccountsReportPage;
